/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_COSTUME_TYPE = gql`
  query GetCostumeType($filter: UniqCostumeTypeFilterInput!) {
    getCostumeType(filter: $filter) {
      presentation {
        name
        id
      }
      section {
        name
        id
      }
      id
      name
      price
      minDownPayment
      costumeFeatures {
        id
        name
        alias
        isSingleAttribute
        isVisible
        isMandatory
        costumeAttributes {
          id
          name
          images
          isMandatory
          isSingleVal
          isVisible
          costumeValues {
            id
            name
            inventory
            deadline
            isVisible
            topupPrice
            disclaimer
            isCostumeValueSold
            minDownPayment
          }
        }
      }
    }
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
  }
`;
